import React from 'react';
import './widgetGrid.scss';
import Habits from './habits';
import Tapestry from './tapestry';
import Population from './population';
import Income from './income';
import esriStrings from '../../resources/esriStrings';

const WidgetGrid = (props) => {
  const gridRef = React.useRef(null);
  const setCurrentVisible = props.setCurrentVisible
  // React.useEffect(() => {
  //   if (gridRef.current) {
  //     setCurrentVisible(2);
  //   }
  // }, [setCurrentVisible]);

  return (
    <>
      <div
        className={`widget-grid${props.isActive ? ' widget-grid-active' : ''}`}
        ref={gridRef}
      >
        <div className="grid-row">
          <div
            className={`widget-cell${
              props.activeWidget === 1 ? ' widget-active' : ''
            }`}
          >
            <Tapestry
              info={esriStrings.tapestryInfo}
              isActive={props.activeWidget === 1}
              activeWidget={props.activeWidget}
              onWidget={props.onWidget}
              widgetData = {props.widgetData.tap}
              currentFeature={props.currentFeature}
              onUpdateLayer={props.onUpdateLayer}
              setActiveLegend={props.setActiveLegend}
            ></Tapestry>
          </div>
          <div
            className={`widget-cell${
              props.activeWidget === 2 ? ' widget-active' : ''
            }`}
          >
            <Habits
              info={esriStrings.habitsInfo}
              isActive={props.activeWidget === 2}
              activeWidget={props.activeWidget}
              onWidget={props.onWidget}
              currentFeature={props.currentFeature}
              onUpdateLayer={props.onUpdateLayer}
              setActiveLegend={props.setActiveLegend}
            ></Habits>
          </div>
        </div>
        <div className="grid-row">
          <div
            className={`widget-cell${
              props.activeWidget === 3 ? ' widget-active' : ''
            }`}
          >
            <Income
              info={esriStrings.incomeInfo}
              isActive={props.activeWidget === 3}
              activeWidget={props.activeWidget}
              onWidget={props.onWidget}
              currentFeature={props.currentFeature}
              onUpdateLayer={props.onUpdateLayer}
              setActiveLegend={props.setActiveLegend}
            ></Income>
          </div>
          <div
            className={`widget-cell${
              props.activeWidget === 4 ? ' widget-active' : ''
            }`}
          >
            <Population
              info={esriStrings.populationInfo}
              isActive={props.activeWidget === 4}
              activeWidget={props.activeWidget}
              onWidget={props.onWidget}
              currentFeature={props.currentFeature}
              onUpdateLayer={props.onUpdateLayer}
              setActiveLegend={props.setActiveLegend}
            ></Population>
          </div>
        </div>
      </div>
    </>
  );
};
export default WidgetGrid;
